export const GET_MENU_LIST = 'GET_MENU_LIST';
export const IS_PLAY_VOICE = 'IS_PLAY_VOICE';
export const ROLE_MENU = 'ROLE_MENU';
export const SET_COLLAPSE = 'SET_COLLAPSE';
export const SET_TOKEN = 'SET_TOKEN';
export const SAVE_USER = 'SAVE_USER';
export const SAVE_HOTEL = 'SAVE_HOTEL';

// isPlayVoice 